export default __webpack_public_path__ + "static/media/broken-heart@2x.b1d492fd.png";